import makeApiCall from "../master/axiosIndex";

const customerAdminApis = {
  fetchSubscriptionOverview: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/super-admin/customer-admin/subscription-overview",
    }),

  fetchAccessCheck: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/super-admin/customer-admin/access-check",
    }),

  fetchBillingConfig: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/super-admin/customer-admin/billing-config",
    }),

  fetchInvoices: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/super-admin/customer-admin/invoices",
      params,
    }),

  fetchInvoiceById: (invoiceId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/customer-admin/invoice/${invoiceId}`,
    }),

  fetchPaymentHistory: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/super-admin/customer-admin/payment-history",
      params,
    }),

  fetchAdvancePayments: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/super-admin/customer-admin/advance-payments",
      params,
    }),

  recordPayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/super-admin/customer-admin/record-payment",
      data,
    }),
};

export default customerAdminApis;
